
const styles = () => ({
  nameFieldClass: {
    width: '100% !important',
  },
});

export default styles;
